import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {AtendimentoDetalhes} from "../../../../core/models/atendimento-detalhes";
import {AtendimentoService} from "../../services/atendimento.service";
import {DetalhesTarefasComponent} from "../../../../core/componentes/detalhes-tarefas/detalhes-tarefas.component";

@Component({
  selector: 'app-atendimento-detalhes-pagina',
  standalone: false,
  templateUrl: './atendimento-detalhes-pagina.component.html',
  styleUrl: './atendimento-detalhes-pagina.component.css'
})
export class AtendimentoDetalhesPaginaComponent implements OnInit {
  id: string;
  atendimento: AtendimentoDetalhes;
  listaAtendimento: AtendimentoDetalhes[] = [];
  showModalDetalhes = false;
  showModalNovoCompromisso = false;
  @ViewChild(DetalhesTarefasComponent) detalhesTarefasComponent: DetalhesTarefasComponent;
  constructor(private route: ActivatedRoute,
              private atendimentoService: AtendimentoService) {
    this.buscarAtendimento();
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.buscarAtendimento();
    });
  }

  private buscarAtendimento() {
    this.atendimentoService.selecionarDetalhesPorId(Number(this.id)).subscribe(response => {
      if(response.sucesso){
        this.atendimento = response.dados;
        this.listaAtendimento.push(response.dados);
      }
    });
  }

  public fecharModalDetalhes(): void {
    this.showModalDetalhes = false;
  }

  public buscarDetalheTarefa(id: number){
    this.showModalDetalhes = true;
    this.detalhesTarefasComponent.buscarTarefaPorId(id);
  }

  public abrirNovoCompromisso(): void {
    this.showModalNovoCompromisso = true;
  }

  public fecharNovoCompromisso(): void {
    this.showModalNovoCompromisso = false;
    this.buscarAtendimento();
  }
}
